module.exports = __webpack_public_path__ + "static/media/immediate.13667c8b.svg";